import { render, staticRenderFns } from "./FormIngreso.vue?vue&type=template&id=34cb2137&scoped=true&"
import script from "./FormIngreso.vue?vue&type=script&lang=js&"
export * from "./FormIngreso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cb2137",
  null
  
)

export default component.exports